import {
  Component,
  OnInit,
  Input,
  ViewChild,
  Output,
  EventEmitter,
  ChangeDetectionStrategy,
} from '@angular/core';
import {
  MatPaginator,
  MatTableDataSource,
  MatSort,
  MatDialog,
} from '@angular/material';
import { Observable } from 'rxjs';
import { DialogBoxComponent } from '../dialog-box/dialog-box.component';

@Component({
  selector: 'makaw-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableComponent implements OnInit {
  @Input() title: string;
  @Input() receivedColumns: any[];
  @Input() receivedRows: Observable<any[]>;
  @Input() actions;
  @Input() showActions: boolean;
  @Output() deletedRow = new EventEmitter<any>();
  @Output() updatedRow = new EventEmitter<any>();
  @Output() newRow = new EventEmitter<any>();
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  public rows;
  public myDataSource;
  public displayedColumns: any[] = ['action'];

  public deleteMsg = 'Are you sure you want to delete this?';
  constructor(public dialog: MatDialog) {}

  ngOnInit() {
    const displayColumnsReceived = this.receivedColumns.map(({ name }) => name);

    this.displayedColumns = this.showActions
      ? (this.displayedColumns = displayColumnsReceived.concat(
          this.displayedColumns
        ))
      : displayColumnsReceived;

    // Receiving rows
    this.receivedRows.subscribe((rows) => {
      console.log(rows);

      this.rows = rows;
      this.myDataSource = new MatTableDataSource<any>(this.rows);

      // table features
      this.myDataSource.paginator = this.paginator;
      this.myDataSource.sort = this.sort;
    });
  }

  // Delete Implementation
  deleteDialog(action, obj) {
    obj.action = action;
    obj.msg = this.deleteMsg;
    const dialogRef = this.dialog.open(DialogBoxComponent, {
      width: '500px',
      data: obj,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result.event === 'Delete') this.deleteRowData(result.data);
    });
  }

  deleteRowData(obj) {
    this.deletedRow.emit(obj);
  }

  updateRow(obj) {
    this.updatedRow.emit(obj);
  }
  createRow() {
    this.newRow.emit();
  }
}
